import { render, staticRenderFns } from "./_system-emails.vue?vue&type=template&id=80eda77c"
import script from "./_system-emails.vue?vue&type=script&lang=js"
export * from "./_system-emails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports